<template>
    <div class="empty-content">
        <div class="empty-icon" />
        <div class="empty-text">
            {{ text }}
        </div>
        <router-link
            :to="{ name: pathName }"
            class="blue-button empty-button"
        >
            Перейти в каталог
        </router-link>
    </div>
</template>

<script>
export default {
    name: "CompetencesEmpty",

    props: {
        competencesType: {
            type: String,
            default: 'soft',
        },
    },

    computed: {
        text() {
            return `Добавьте ${ this.competencesType === 'soft' ? 'компетенции' : 'профессиональные навыки'}`;
        },

        pathName() {
            return this.competencesType === 'soft' ? 'competences' : 'professional-skills';
        },
    },
};
</script>

<style lang="scss" scoped>
.empty {
    &-content {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        margin: 140px 0 0 0;
    }

    &-icon {
        width: 48px;
        height: 48px;
        margin: 0 0 16px 0;
        background: url("~@/assets/images/account-track/icon/empty-competences-icon.svg") no-repeat center/contain;
    }

    &-text {
        max-width: 256px;
        margin: 0 0 24px 0;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #98A0A9;
    }

    &-button {
        width: 256px;
        height: 40px;
        border-radius: 4px;
        font-size: 16px;
        line-height: 24px;
    }
}
</style>